<template>
  <v-container>
    <module-bar :title="title" icon="mdi-currency-usd-off" />

    <v-card outlined>
      <v-card-text>
        <v-form v-model="valid" ref="forSpent">
          <v-row>
            <v-col cols="12" md="6">
              <v-select :disabled="schema == 'edit'" label="Selecciona el lider" v-model="employee_id" :items="liders"
                item-text="name" item-value="id" :rules="rulesEmployee" :loading="loadingLiders" />
            </v-col>

            <v-col cols="12" md="6">
              <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="date" label="Fecha del gasto" prepend-icon="mdi-calendar" readonly
                    v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker locale="es" v-model="date" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12">
              <v-textarea outlined label="Descripcion del gasto" v-model="description" :rules="rulesDescription" />
            </v-col>
            <v-col cols="12" md="6">
              <v-file-input label="Capture de transferencia" v-model="capture" show-size
                accept="image/png, image/jpeg, image/bmp" :rules="rulesPhoto" />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field label="Monto" type="number" v-model="amount" :rules="rulesAmount" />
            </v-col>

            <v-col cols="12" md="6" v-if="spent">
              <v-img style="cursor: pointer" v-if="spent.capture" width="200" :src="spent.capture"
                :lazy-src="spent.capture_thumb" aspect-ratio="1" contain class="grey lighten-2"
                @click="openDialogCapture(spent.capture, 1)">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>

          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="red" v-if="schema == 'edit'" @click="closeDialogSpentDetails(null)">cancelar</v-btn>
        <v-btn :loading="loadingProcess" @click="processSpent" text color="primary">{{ schema == "new" ?
          "GUARDAR" :
          "EDITAR"
        }}</v-btn>
      </v-card-actions>
    </v-card>

    <!-- dialogo foto -->
    <v-dialog v-if="spent" v-model="dialogPhoto" width="auto" min-width="500" max-width="800">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-row justify="center">
              <v-img :src="photoSelected" max-width="500px" />
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn text color="red" @click="deletePhoto" :loading="loadingDeletePhoto">eliminar foto</v-btn>
          <v-spacer />
          <v-btn text @click="closeDialogPhoto">cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ModuleBar from "../General/ModuleBar.vue";

export default {
  components: { ModuleBar },
  props: ["schema", "title", "spent", "click"],

  mounted() {
    this.loadLiders();

    if (this.spent) {
      this.loadSpent();
    }
  },

  data() {
    return {
      menu2: false,
      date: new Date().toISOString().substr(0, 10),
      loadingDelete: false,
      dialogPhoto: false,
      loadingDeletePhoto: false,
      valid: false,
      loadingProcess: false,
      employee_id: 0,
      capture: null,
      description: "",
      amount: 0,
      loadingLiders: false,
      liders: [],
      photoSelected: "",

      rulesEmployee: [(value) => (value && value > 0) || "Seleccione el Lider"],
      rulesDescription: [
        (value) =>
          (value && value.length > 0) || "Ingrese una descripcion del gasto",
      ],

      rulesAmount: [
        (value) => (value && value.toString().length > 0 || "Ingrese el monto")
      ],

      rulesPhoto: [
        (value) =>
          !value ||
          value.size < 400000 ||
          "La foto no puede pesar mas de  400 Kb!",
      ],
    };
  },

  watch: {
    click() {
      this.loadSpent();
    },

    name(value) {
      this.name = value.toUpperCase();
    },
  },

  methods: {
    processSpent() {
      if (this.valid) {
        this.loadingProcess = true;
        setTimeout(() => {
          let payload = new FormData();

          payload.append("employee_id", this.employee_id);
          payload.append("date", this.date);
          payload.append("description", this.description);
          payload.append("capture", this.capture);
          payload.append("amount", this.amount);

          if (this.schema == "edit") payload.append("spent_id", this.spent.id);

          let path =
            this.schema == "new" ? "storeSpentAction" : "updateSpentAction";

          this.$store
            .dispatch(path, payload)
            .then((res) => {
              this.loadingProcess = false;
              if (this.schema == "edit") this.closeDialogSpentDetails(res);
              this.clear();
            })
            .catch(() => {
              this.loadingProcess = false;
            });
        }, 500);
      } else {
        this.$refs.forSpent.validate();
      }
    },

    clear() {
      this.description = "";
      this.amount = 0;
      this.capture = null;
      this.date = new Date().toISOString().substr(0, 10),
        this.employee_id = 0;
      this.$refs.forSpent.resetValidation();
    },

    closeDialogSpentDetails(data) {
      this.$emit("closeDialogSpentDetails", data);
    },

    loadSpent() {
      if (this.spent) {
        this.employee_id = this.spent.employee_id;
        this.description = this.spent.description;
        this.amount = this.spent.amount;
        this.date = this.spent.date ? this.spent.date.substr(0, 10) : new Date().toISOString().substr(0, 10);
      }
    },

    openDialogCapture(photo, number) {
      this.dialogPhoto = true;
      this.photoSelected = photo;
      this.photoNumber = number;
    },

    closeDialogPhoto() {
      this.dialogPhoto = false;
      this.photoSelected = "";
    },

    deletePhoto() {
      this.$confirm({
        message: `Quieres eliminar este capture?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.loadingDeletePhoto = true;
            setTimeout(() => {

              let payload = {
                id: this.spent.id,
              }
              this.$store
                .dispatch("deleteCaptureSpentAction", payload)
                .then(() => {
                  this.loadingDeletePhoto = false;
                  this.dialogPhoto = false;
                  this.photoFinish();
                })
                .catch(() => {
                  this.loadingDeletePhoto = false;
                });
            }, 500);
          }
        },
      });
    },

    photoFinish() {
      this.spent.capture = null;
      this.spent.capture_short = null;
      this.spent.capture_thumb = null;
      this.spent.capture_thumb_short = null;
    },

    loadLiders() {
      this.loadingLiders = true;
      setTimeout(() => {
        this.$store.dispatch("findLiders").then((res) => {
          this.liders = res;
          this.loadingLiders = false;
        });
      }, 500);
    },
  },
};
</script>

<style></style>